import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import StoryExperience from "@/components/StoryExperience";
import { getCategoryPageBySlug } from "@/lib/category-pages.functions";

const INFO_SLUG = "info";
const INFO_URL = "https://www.travelbackland.com/info";

export const Route = createFileRoute("/info")({
  head: () => ({
    meta: [
      { title: "Info — Backland Luxury Nature Resort, Arizona" },
      {
        name: "description",
        content:
          "FAQs, contact details, and the Backland blog — everything you need to plan your stay.",
      },
      { property: "og:title", content: "Info — Backland" },
      {
        property: "og:description",
        content: "FAQs, contact, and stories from Backland.",
      },
      { property: "og:url", content: INFO_URL },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: INFO_URL }],
  }),
  component: InfoRoute,
});

function InfoRoute() {
  const fetchPage = useServerFn(getCategoryPageBySlug);
  const { data: page } = useQuery({
    queryKey: ["category-page", INFO_SLUG],
    queryFn: () => fetchPage({ data: { slug: INFO_SLUG } }),
    staleTime: 60_000,
  });

  const ldJson = page
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: page.items.map((it) => ({
          "@type": "Question",
          name: it.question,
          acceptedAnswer: { "@type": "Answer", text: it.answer },
        })),
      }
    : null;

  return (
    <>
      {ldJson && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }}
        />
      )}
      <StoryExperience initialCategorySlug={INFO_SLUG} />
    </>
  );
}
